import { TableERP } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { EntidadConciliableReadingDtoProps } from "api/DTOs/EntidadConciliableReadingDto"
import { GetFlujosConciliablesDtoProps } from "api/DTOs/GetFlujosConciliablesDto"
import { GetFacturasConciliablesDtoProps } from "api/Schemas/GetFacturasConciliablesDtoProps"
import { useTranslation } from "react-i18next"
import { CONCILIACION_MANUAL_SELECTED_COLUMNS_RIGHT } from "./panelConciliablesColumns"

export interface DrawerDocumentosSeleccionadosProps {
  isLowerSectionExpanded: boolean
  selectedDocuments: Array<
    | EntidadConciliableReadingDtoProps
    | GetFacturasConciliablesDtoProps
    | GetFlujosConciliablesDtoProps
  >
  toggleLowerSection: () => void
  unSelectedRow: (rowData: EntidadConciliableReadingDtoProps) => void
}

export const DrawerDocumentosSeleccionados = ({
  isLowerSectionExpanded,
  selectedDocuments,
  toggleLowerSection,
  unSelectedRow,
}: DrawerDocumentosSeleccionadosProps) => {
  const { t } = useTranslation()
  return (
    <div
      className={`tw-border-t tw-bg-white tw-py-3 tw-transition-all tw-duration-2000 tw-ease-in-out tw-z-50 tw-absolute ${
        isLowerSectionExpanded
          ? "tw-top-0 tw-left-0 tw-w-full tw-h-full"
          : "tw-h-16 tw-w-full tw-overflow-hidden tw-flex-none"
      }`}
    >
      <div className='tw-mx-auto tw-h-1 tw-w-10 tw-rounded tw-bg-gray-300' />
      <div
        className='tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2 tw-p-2'
        onClick={toggleLowerSection}
      >
        <h2 className='tw-text-base tw-font-normal tw-text-text-hyperlinks'>
          {`${selectedDocuments?.length} seleccionados`}
        </h2>
        <button
          type='button'
          className='tw-hover:bg-gray-200 tw-h-5 tw-w-5 tw-transition-colors tw-duration-100'
        >
          <FontAwesomeIcon
            icon={["fal", "angle-up"]}
            className={`tw-h-5 tw-w-5 tw-text-text-hyperlinks tw-transition-transform tw-duration-100 ${
              isLowerSectionExpanded ? "tw-rotate-180 tw-transform" : ""
            }`}
          />
        </button>
      </div>
      <div
        className={`tw-scrollbar-thin tw-overflow-y-auto tw-transition-all tw-duration-100 ${
          isLowerSectionExpanded ? "tw-max-h-[calc(100%-3rem)]" : "tw-max-h-0"
        }`}
      >
        <div className='tw-h-[calc(100%-60px)] tw-min-h-0'>
          <TableERP
            columns={CONCILIACION_MANUAL_SELECTED_COLUMNS_RIGHT(
              t,
              unSelectedRow
            )}
            className='tw-h-full tw-max-w-full'
            columnResizeMode='expand'
            removableSort
            value={selectedDocuments ?? []}
            showGridlines
            dataKey='idExterno'
            lazy
            scrollable
            size='small'
            emptyMessage={`${t("primeReact.table.notSelected")}`}
          />
        </div>
      </div>
    </div>
  )
}
